// Strings for S6. Only the S6 worker edits this file (see web/README.md).
// One screen, branched by disruption type (ux-flow.md S6). Copy from prototype/assets/app.js
// (screens.S6, the docgate sheet); DRAFT = no source there (w2-03 report).
export default {
  // Working name for the loading state's document title; the question itself titles the page.
  title: 'The legal question',
  'delayed.q': 'How late did you arrive in {city} ({iata})?',
  'missed.q': 'How late did you reach {city} ({iata})?',
  'missed.sub': 'Measured at your final destination, not the airport where you changed planes.',
  'delay.3h': '3 hours or more',
  'delay.under3h': 'Less than 3 hours',
  'delay.never': 'I never arrived',
  // w5-06 (Q39): over 3,500 km (the quote's band `long`), "3 hours or more" is split: 3–4 h pays half.
  'delay.4hOrMore': '4 hours or more', // decision 39's wording
  'delay.3to4h': '3–4 hours', // decision 39's wording
  'delay.longHaulNote':
    'On a flight this long, 3 to 4 hours late pays half, and more than that pays in full.', // DRAFT
  'cancelled.q': 'How far in advance were you told about the cancellation?',
  'cancelled.lt14': 'Less than 14 days',
  'cancelled.ge14': '14 days or more',
  'cancelled.notTold': "I wasn't told at all",
  'denied.q': 'Did you volunteer to give up your seat for benefits?',
  'denied.no': 'No, I was turned away',
  'denied.yes': 'Yes, I volunteered',
  'gate.title': 'Did you have the right documents?',
  'gate.note': 'A valid passport, any visa you needed, and a booking for this flight.',
  'gate.yes': 'Yes, continue',
  'gate.no': 'No — I was missing something',
  saveFailed: "That didn't save. Check your connection and try again.", // DRAFT
} as const;
